import { ButtonStyles } from '../types'
import { colorPalette } from './color-palette'

const storePalette = colorPalette.clearly

const {
  white,
  black,
  light2,
  blue,
  light1,
  grey,
} = storePalette

const primaryDarkStyle = {
  background: black,
  color: white,
  borderColor: black,
  iconStrokeColor: 'transparent',
  iconFillColor: white,
  hover: {
    background: light1.grey,
    color: white,
    borderColor: light1.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

const primaryLightStyle = {
  background: white,
  color: black,
  borderColor: white,
  iconStrokeColor: 'transparent',
  iconFillColor: black,
  hover: {
    background: light1.grey,
    color: white,
    borderColor: light1.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

const primaryDarkHoverVariant = {
  background: black,
  color: white,
  borderColor: black,
  iconStrokeColor: 'transparent',
  iconFillColor: white,
  hover: {
    background: light2.grey,
    color: black,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: black,
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

const primaryLightHoverVariant = {
  background: white,
  color: black,
  borderColor: white,
  iconStrokeColor: 'transparent',
  iconFillColor: black,
  hover: {
    background: light2.grey,
    color: black,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: black,
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

const secondaryDarkStyle = {
  background: 'transparent',
  color: black,
  borderColor: black,
  iconStrokeColor: 'transparent',
  iconFillColor: black,
  hover: {
    background: light1.grey,
    color: white,
    borderColor: grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

const secondaryLightStyle = {
  background: 'transparent',
  color: white,
  borderColor: white,
  iconStrokeColor: 'transparent',
  iconFillColor: white,
  hover: {
    background: grey,
    color: white,
    borderColor: white,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

const tertiaryDarkStyle = {
  background: blue,
  color: white,
  borderColor: blue,
  iconStrokeColor: 'transparent',
  iconFillColor: white,
  hover: {
    background: light2.blue,
    color: black,
    borderColor: light2.blue,
    iconStrokeColor: 'transparent',
    iconFillColor: black
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

const tertiaryLightStyle = {
  background: 'transparent',
  color: black,
  borderColor: 'transparent',
  iconStrokeColor: 'transparent',
  iconFillColor: black,
  hover: {
    background: 'transparent',
    color: blue,
    borderColor: 'transparent',
    iconStrokeColor: 'transparent',
    iconFillColor: blue,
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

const secondaryDarkHoverVariant = {
  background: 'transparent',
  color: black,
  borderColor: black,
  iconStrokeColor: 'transparent',
  iconFillColor: black,
  hover: {
    background: 'transparent',
    color: light1.grey,
    borderColor: light1.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: light1.grey,
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

const secondaryLightHoverVariant = {
  background: 'transparent',
  color: white,
  borderColor: white,
  iconStrokeColor: 'transparent',
  iconFillColor: white,
  hover: {
    background: light1.grey,
    color: white,
    borderColor: white,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  },
  disabled: {
    background: light2.grey,
    color: white,
    borderColor: light2.grey,
    iconStrokeColor: 'transparent',
    iconFillColor: white,
  }
} as ButtonStyles

/**
 * Default color palette for button variants
 */
export const buttonVariantStyles = {
  fill: {
    primary: {
      dark: primaryLightStyle,
      light: primaryDarkStyle,
    },
    secondary: {
      dark: secondaryLightStyle,
      light: secondaryDarkStyle,
    },
    tertiary: {
      dark: tertiaryLightStyle,
      light: tertiaryDarkStyle,
    },
  },
  outline: {
    primary: {
      dark: secondaryLightStyle,
      light: secondaryDarkStyle,
    },
    secondary: {
      dark: secondaryDarkStyle,
      light: secondaryLightStyle,
    },
    tertiary: {
      dark: tertiaryDarkStyle,
      light: tertiaryLightStyle,
    },
  }
}